import { number } from './format'

/**
 * One way to state a license quantity everywhere a customer reads it: the
 * total for the term, then the term ("2,500 licenses over 2 years"). A
 * one-year term reads "1,000 licenses for 1 year".
 */
export function licenseTermPhrase(licensesPerYear: number, termYears: number): string {
  const years = wholeYears(termYears)
  const total = Math.max(0, Math.floor(licensesPerYear || 0)) * years
  const noun = total === 1 ? 'license' : 'licenses'
  return years === 1 ? `${number(total)} ${noun} for 1 year` : `${number(total)} ${noun} over ${years} years`
}

/** The yearly split of a multi-year quantity ("1,250 a year"), or null for a one-year term. */
export function licensesPerYearPhrase(licensesPerYear: number, termYears: number): string | null {
  return wholeYears(termYears) > 1 ? `${number(Math.max(0, Math.floor(licensesPerYear || 0)))} a year` : null
}

/** "1 year" or "2 years". */
export function termPhrase(termYears: number): string {
  const years = wholeYears(termYears)
  return `${years} ${years === 1 ? 'year' : 'years'}`
}

function wholeYears(termYears: number): number {
  return Math.max(1, Math.floor(termYears || 1))
}
